import { IEntitlement } from "../dto/entitlement";

export default function (): Promise<IEntitlement[]> {
  return fetch(`/twitch/entitlements${window.location.search}`)
    .then((response) => response.json())
    .catch(() => []);
}
